// Cache the masked lighting result; never composite onto the opaque city canvas.
const cache = new WeakMap<HTMLImageElement | HTMLCanvasElement, Map<string, HTMLCanvasElement>>();
export function lightCharacter(sprite: HTMLImageElement | HTMLCanvasElement, overlay: HTMLImageElement, column: number, row: number, singleFrame: boolean) {
  let frames = cache.get(sprite);
  if (!frames) { frames = new Map(); cache.set(sprite, frames); }
  const key = `${overlay.src}:${column}:${row}:${singleFrame}`;
  const existing = frames.get(key);
  if (existing) return existing;
  const frame = document.createElement('canvas');
  frame.width = frame.height = 112;
  const ctx = frame.getContext('2d');
  if (!ctx) return null;
  ctx.imageSmoothingEnabled = false;
  const width = 'naturalWidth' in sprite ? sprite.naturalWidth : sprite.width;
  const height = 'naturalHeight' in sprite ? sprite.naturalHeight : sprite.height;
  if (singleFrame) ctx.drawImage(sprite, 0, 0, 112, 112, 0, 0, 112, 112);
  else ctx.drawImage(sprite, column * width / 3, row * height / 2, width / 3, height / 2, 0, 0, 112, 112);
  ctx.globalCompositeOperation = 'source-atop';
  ctx.drawImage(overlay, 0, 0, 112, 112);
  ctx.globalCompositeOperation = 'source-over';
  frames.set(key, frame);
  return frame;
}
